import React, { useState, useEffect } from 'react';
import { FiPlus, FiEdit2, FiTrash2 } from 'react-icons/fi';
import { api } from '../api';
import { useMe } from '../App';
import { findPerm } from '../perm';

export default function Roles() {
  const me = useMe();
  const perm = findPerm(me.modules, 'roles');
  const [rows, setRows] = useState(null);
  const [modal, setModal] = useState(null);
  const [toast, setToast] = useState('');

  async function load() {
    try { setRows(await api('/roles')); } catch (e) { setToast(e.message); }
  }
  useEffect(() => { load(); }, []);
  function flash(m) { setToast(m); setTimeout(() => setToast(''), 2600); }

  async function remove(role) {
    if (!window.confirm(`Delete role "${role.name}"?`)) return;
    try { await api('/roles/' + role.id, { method: 'DELETE' }); flash('Role deleted'); load(); }
    catch (e) { flash(e.message); }
  }

  return (
    <div>
      <div className="mod-head">
        <div className="titles">
          <div className="page-eyebrow">Masters</div>
          <h1>Roles</h1>
          <div className="count">{rows ? `${rows.length} role${rows.length !== 1 ? 's' : ''}` : 'Loading…'}</div>
        </div>
        {perm.can_create && (
          <button className="btn btn-dark" onClick={() => setModal({ mode: 'add', role: { name: '', description: '' } })}>
            <FiPlus /> Add role
          </button>
        )}
      </div>

      <div className="table-card">
        {!rows ? <div className="empty">Loading…</div> :
          <table className="data">
            <thead>
              <tr>
                <th>Role</th><th>Description</th><th>Users</th>
                {(perm.can_edit || perm.can_delete) && <th style={{ textAlign: 'right' }}>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td style={{ fontWeight: 600 }}>
                    {r.name} {r.is_core && <span className="pill pill-muted" style={{ marginLeft: 6 }}>Core</span>}
                  </td>
                  <td style={{ color: 'var(--muted)' }}>{r.description || '—'}</td>
                  <td><span className="pill pill-muted">{r.user_count}</span></td>
                  {(perm.can_edit || perm.can_delete) && (
                    <td>
                      <div className="row-actions">
                        {perm.can_edit && <button className="btn btn-sm" onClick={() => setModal({ mode: 'edit', role: r })}><FiEdit2 /> Edit</button>}
                        {perm.can_delete && !r.is_core && <button className="btn btn-sm btn-danger" onClick={() => remove(r)}><FiTrash2 /> Delete</button>}
                      </div>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>}
      </div>

      {modal && <RoleModal {...modal} onClose={() => setModal(null)} onSaved={(m) => { setModal(null); flash(m); load(); }} />}
      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}

function RoleModal({ mode, role, onClose, onSaved }) {
  const [name, setName] = useState(role.name || '');
  const [description, setDescription] = useState(role.description || '');
  const [error, setError] = useState(''); const [busy, setBusy] = useState(false);

  async function save() {
    setError(''); setBusy(true);
    try {
      if (mode === 'add') { await api('/roles', { method: 'POST', body: { name, description } }); onSaved('Role added'); }
      else { await api('/roles/' + role.id, { method: 'PUT', body: { name, description } }); onSaved('Role updated'); }
    } catch (e) { setError(e.message); setBusy(false); }
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{mode === 'add' ? 'Add role' : 'Edit role'}</h2>
        <div className="field"><label>Role name</label>
          <input value={name} autoFocus onChange={(e) => setName(e.target.value)} placeholder="e.g. Accounts" />
        </div>
        <div className="field"><label>Description</label>
          <input value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Optional" />
        </div>
        {error && <div className="inline-error">{error}</div>}
        <div className="modal-actions">
          <button className="btn" onClick={onClose} disabled={busy}>Cancel</button>
          <button className="btn btn-dark" onClick={save} disabled={busy || !name.trim()}>{busy ? 'Saving…' : 'Save'}</button>
        </div>
      </div>
    </div>
  );
}
